var IMAGE_SOURCES_MAX_LENGTH = 100000;
var BIBLIOGRAPHY_MAX_LENGTH = 50000;
export var onChangeBibliography = function (e, style, toasts, setState) {
    var maxLength = style === 'image_sources'
        ? IMAGE_SOURCES_MAX_LENGTH
        : BIBLIOGRAPHY_MAX_LENGTH;
    if (e.target.value.length < maxLength) {
        setState({
            text: e.target.value
        });
    }
    if (e.target.value.length >= maxLength) {
        toasts.error('Максимальная длина: ' + maxLength + ' символов');
        setState({
            text: e.target.value.substring(0, maxLength - 3)
        });
    }
};
//# sourceMappingURL=onChangeBibliography.js.mapvar IMAGE_SOURCES_MAX_LENGTH = 100000;
var BIBLIOGRAPHY_MAX_LENGTH = 50000;
export var onChangeBibliography = function (e, style, toasts, setState) {
    var maxLength = style === 'image_sources'
        ? IMAGE_SOURCES_MAX_LENGTH
        : BIBLIOGRAPHY_MAX_LENGTH;
    if (e.target.value.length < maxLength) {
        setState({
            text: e.target.value
        });
    }
    if (e.target.value.length >= maxLength) {
        toasts.error('Максимальная длина: ' + maxLength + ' символов');
        setState({
            text: e.target.value.substring(0, maxLength - 3)
        });
    }
};
//# sourceMappingURL=onChangeBibliography.js.map